import { styled } from "@mui/material/styles";

export const StyledImageButton = styled("img", {
  shouldForwardProp: (prop) => prop !== 'is_disabled'
})<{ is_disabled?: boolean }>(({ is_disabled }) => ({
  cursor: is_disabled ? "not-allowed" : "pointer", // ここを修正
  WebkitTapHighlightColor: "transparent",
  transition: "transform 0.1s ease-in-out, opacity 0.1s ease-in-out",
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    opacity: is_disabled ? 1 : 0.9, // 非活性時は透明度を変えない
    transform: is_disabled ? "scale(1)" : "scale(1.01)", // 非活性時は拡大しない
  },
  "&:active": {
    transform: is_disabled ? "scale(1)" : "scale(0.98)", // 非活性時は縮小しない
    opacity: is_disabled ? 1 : 0.85, // 非活性時は透明度を変えない
  },
}));